export const PAGE_LINKS = {
  home: '/',
  pdf: '/webapp/pdf',
  oldPdf: '/pdf',
  uninstall: '/uninstall',
  install: '/install',
  login: '/login',
  welcome: '/welcome',
  pricing: '/pricing',
  invite: '/invite',
  help: '/help',
  share_wx_mp: '/share_wx_mp',
  onlineTranslation: '/online_translation/:sourceToTarget?',
  h5_invite: '/H5/invite',
  h5_price: '/H5/price',
  h5_exchange: '/H5/exchange',
  education_incentives: '/education_incentives',
  learning: '/learning',
  guide: '/guide',
  pdf_pro: '/pdf_pro',
  aiPdfTranslator: '/ai-pdf-translator/:sourceToTarget?',
  sidePanelGuide: '/side_panel_guide',
  dashboard: '/dashboard',
  word: '/word',
  pdf_ultra: '/pdf_ultra',
}

export const ICONFONT_SCRIPT_URL = '//at.alicdn.com/t/c/font_4393329_wxib7mimprh.js'

export const Z_INDEX_MAX = 2147483647

export const HY_DIALOG_PARENT_NO_SCROLL_CLASS = 'huiyi-dialog-parent-no-scroll'
export const HY_GLOBAL_STYLE_CLS = 'huiyi-global'
